(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sph-bundle-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sph-bundle-builder')) {
 customElements.define('sph-bundle-builder', class extends HTMLElement {
  connectedCallback() {
   if (this.initialised) return;
   this.initialised = true;
   this.money = new Intl.NumberFormat(this.dataset.locale || 'en-GB', {style:'currency',currency:this.dataset.currency || 'GBP'});
   this.addEventListener('change', event => {
    let message = '';
    const limit = Number(this.querySelector('[data-pack-size]').value);
    const checked = [...this.querySelectorAll('[data-support]:checked')];
    if (event.target.matches('[data-support]') && checked.length > limit) { event.target.checked = false; message = this.dataset.limit; }
    if (event.target.matches('[data-pack-size]') && checked.length > limit) { checked.slice(limit).forEach(input => {input.checked=false;}); message=this.dataset.reduced; }
    this.update(message);
   });
   this.querySelector('[data-add-selection]').addEventListener('click', () => this.addSelection());
   this.update();
  }
  async addSelection() {
   if (this.busy || this.needsReview) return;
   this.update();
   if (this.dataset.complete !== 'true') return;
   const items=this.selectedItems.map(item=>({id:item.id,quantity:1}));
   if(new Set(items.map(item=>item.id)).size!==items.length) return;
   this.busy=true;
   this.update(this.dataset.adding);
   const controls=[...this.querySelectorAll('input,select')];
   const disabled=controls.map(control=>control.disabled);
   controls.forEach(control=>{control.disabled=true;});
   let attempted=false;
   try {
    const current=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!current.ok) throw new Error();
    const cart=await current.json();
    const existing=new Set(cart.items.filter(item=>!item.selling_plan_allocation).map(item=>String(item.variant_id)));
    const missing=items.filter(item=>!existing.has(String(item.id)));
    if(missing.length) {
     attempted=true;
     const added=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:missing})});
     if(!added.ok) throw new Error();
     await added.json();
    }
    window.location.assign(this.dataset.cartUrl);
   } catch(error) {
    this.busy=false;
    this.needsReview=attempted;
    controls.forEach((control,index)=>{control.disabled=disabled[index];});
    this.querySelector('[data-review-cart]').hidden=false;
    this.update(attempted?this.dataset.reviewError:this.dataset.cartError);
   }
  }
  update(message='') {
   const levels = this.querySelector('[name^="bundle-mode"]:checked').value === 'levels';
   this.querySelector('[data-performance-panel]').hidden=levels;
   this.querySelector('[data-levels-panel]').hidden=!levels;
   const count=Number(this.querySelector('[data-pack-size]').value);
   const checked=[...this.querySelectorAll('[data-support]:checked')];
   this.querySelector('[data-count]').textContent=`${checked.length} / ${count} ${this.dataset.selected}`;
   let items=[],subtotal=0,total=0,ready=false;
   if (levels) {
    const pack=this.querySelector('[data-level]:checked');
    if(pack) {items=[...pack.closest('.sph-bundles__level').querySelectorAll('[data-level-product]')].map(x=>({title:x.dataset.title,price:Number(x.dataset.price),id:x.dataset.variant}));ready=items.length===3;}
    subtotal=items.reduce((sum,item)=>sum+item.price,0);total=Math.round(subtotal*0.8);
   } else {
    const option=this.querySelector('[data-development]').selectedOptions[0];
    const link=this.querySelector('[data-development-link]');link.hidden=!option.value;if(option.value)link.href=option.dataset.url;
    if(option.value)items.push({title:option.dataset.title,price:Number(option.dataset.price),id:option.value});
    const support=checked.map(x=>({title:x.dataset.title,price:Number(x.dataset.price),id:x.value}));items.push(...support);
    subtotal=items.reduce((sum,item)=>sum+item.price,0);
    ready=Boolean(option.value)&&support.length===count;
    const supportTotal=support.reduce((sum,item)=>sum+item.price,0);
    total=ready?Number(option.dataset.price)+Math.round(supportTotal*(count===2?0.75:0.7)):subtotal;
   }
   const list=this.querySelector('[data-selected-list]');list.replaceChildren();
   for(const item of items){const li=document.createElement('li');li.textContent=item.title;list.append(li);}
   if(!items.length){const li=document.createElement('li');li.textContent=this.dataset.empty;list.append(li);}
   this.querySelector('[data-subtotal]').textContent=this.money.format(subtotal/100);
   this.querySelector('[data-saving]').textContent=this.money.format((subtotal-total)/100);
   this.querySelector('[data-total]').textContent=this.money.format(total/100);
   this.querySelector('[data-status]').textContent=message || (ready?this.dataset.ready:levels?this.dataset.needCollection:this.dataset.need);
   ready=ready && new Set(items.map(item=>item.id)).size===items.length;
   this.selectedItems=items;
   this.dataset.complete=String(ready);
   this.querySelector('[data-add-selection]').disabled=!ready || Boolean(this.busy) || Boolean(this.needsReview);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-pathways"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sph-guide-finder')) {
  customElements.define('sph-guide-finder', class extends HTMLElement {
    connectedCallback() {
      this.roleSelect = this.querySelector('[data-role]');
      this.sportSelect = this.querySelector('[data-sport]');
      this.destination = this.querySelector('[data-destination]');
      if (!this.roleSelect?.options.length || !this.sportSelect || !this.destination) return;
      this.onChange = () => this.updateDestination();
      this.addEventListener('change', this.onChange);
      this.updateDestination();
      this.hidden = false;
    }
    disconnectedCallback() { this.removeEventListener('change', this.onChange); }
    updateDestination() {
      const role = this.roleSelect.selectedOptions[0];
      for (const option of this.sportSelect.options) option.disabled = !role.dataset[option.value];
      if (this.sportSelect.selectedOptions[0].disabled) this.sportSelect.value = 'base';
      this.destination.href = role.dataset[this.sportSelect.value] || role.dataset.base;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-product-topics"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.sph-product-jumps a[href="#guide-description"]');
  if (!link) return;
  const description = document.querySelector('.product-info [data-block-type="description"] details');
  if (!description) return;
  description.open = true;
  const summary = description.querySelector('summary');
  if (summary) summary.focus({preventScroll: true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sph-support-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sph-support-directory')) {
 customElements.define('sph-support-directory', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   const input = this.querySelector('input');
   const cards = [...this.querySelectorAll('.sph-support__card')];
   const status = this.querySelector('[role="status"]');
   const filter = () => {
    const terms = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
    let count = 0;
    cards.forEach(card => { card.hidden = !terms.every(term => card.textContent.toLocaleLowerCase().includes(term)); if (!card.hidden) count++; });
    this.querySelectorAll('.sph-support__group').forEach(group => { group.hidden = ![...group.querySelectorAll('.sph-support__card')].some(card => !card.hidden); });
    this.querySelector('.sph-support__empty').hidden = count !== 0;
    this.querySelector('.sph-support__nav').hidden = terms.length > 0;
    status.textContent = `${count} ${status.dataset.label}`;
   };
   input.addEventListener('input', filter);
   this.querySelector('button').addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
   this.querySelector('.sph-support__tools').hidden = false;
   filter();
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
